import { useContext } from "react";
import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { AuthContext } from "../context/AuthContext";

interface Props {
  children: ReactNode;
  requiredRole?: string;
  requiredRoles?: string[];
}

const ProtectedRoute = ({ children, requiredRole, requiredRoles }: Props) => {
  const { token, user, loading } = useContext(AuthContext);

  
  if (loading) {
    return null; 
  }

  
  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredRoles && (!user?.role || !requiredRoles.includes(user.role))) {
    return <Navigate to="/dashboard" replace />;
  }

  
  return <>{children}</>;
};

export default ProtectedRoute;
